import { useState } from "react";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { api, inr, newRef, today, useLoad, useSubmit } from "@/lib/api";
import { ErrorBox, Field, Modal } from "@/components/common";
import PatientPicker from "@/components/PatientPicker";

const TYPES = [{ value: "payment", label: "Payment / advance received" }, { value: "discount", label: "Discount given" }, { value: "refund", label: "Refund paid back" }];

export default function TransactionForm({ patientId, onClose, onSaved }) {
  const [form, setForm] = useState({ patient_id: patientId || "", type: "payment", amount: "", method: "Cash", date: today(), treatment_id: "", notes: "" });
  const [clientRef] = useState(newRef);
  const { data: meta } = useLoad("/meta", { payment_methods: ["Cash"] });
  const { data: treatments } = useLoad(form.patient_id ? `/treatments?patient_id=${form.patient_id}` : "", []);
  const { busy, error, run } = useSubmit();
  const set = (k) => (v) => setForm({ ...form, [k]: v });
  const save = () => run(async () => {
    const r = await api.post("/payments", { ...form, amount: Number(form.amount), client_ref: clientRef });
    toast.success(`${TYPES.find((t) => t.value === form.type).label.split(" ")[0]} of ${inr(r.data.amount)} recorded`);
    onSaved(r.data);
  });
  const linkable = [{ value: "", label: "Not linked to a treatment" }, ...treatments.filter((t) => t.status !== "cancelled").map((t) => ({ value: t.id, label: `${t.treatment}${t.tooth ? ` (${t.tooth})` : ""} · ${inr(t.agreed_amount)}` }))];
  return (
    <Modal eyebrow="PATIENT PAYMENTS" title="Record transaction" onClose={onClose} onSubmit={save} testid="transaction-form">
      {!patientId && <PatientPicker value={form.patient_id} onChange={(v) => setForm({ ...form, patient_id: v, treatment_id: "" })} testid="transaction-patient-select" />}
      <Field label="Type" testid="transaction-type-select" value={form.type} onChange={set("type")} options={TYPES} />
      <div className="form-two">
        <Field label="Amount (₹)" type="number" min="0.01" step="0.01" testid="transaction-amount-input" required value={form.amount} onChange={set("amount")} />
        <Field label="Date" type="date" testid="transaction-date-input" required value={form.date} onChange={set("date")} />
      </div>
      {form.type !== "discount" && <Field label="Payment method" testid="transaction-method-select" value={form.method} onChange={set("method")} options={meta.payment_methods} />}
      <Field label="Linked treatment" testid="transaction-treatment-select" value={form.treatment_id} onChange={set("treatment_id")} options={linkable} />
      <Field label="Notes" textarea testid="transaction-notes-input" value={form.notes} onChange={set("notes")} rows={2} />
      <ErrorBox error={error} testid="transaction-form-error" />
      <button className="primary full" disabled={busy} data-testid="save-transaction-button"><Check size={17} /> {busy ? "Saving…" : "Save transaction"}</button>
    </Modal>
  );
}
